import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VImg,{attrs:{"src":_vm.href,"eager":"","contain":"","id":_vm.src,"align":"center"},on:{"click":function($event){return _vm.$emit('click')}},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c(VRow,{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c(VProgressCircular,{attrs:{"indeterminate":"","color":"primary"}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }